import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButton = styled.a.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-19lrliq-0"
})(["background:#eaf0f6;border:1px solid #cbd6e2;color:#506e91;font-size:12px;line-height:14px;padding:8px 16px;border-radius:3px;font-family:'Lexend Deca',Helvetica,Arial,sans-serif;font-weight:400;text-align:center;text-transform:capitalize;text-decoration:none;:hover{background:#f5f8fa;color:#506e91;text-decoration:none;}:active{background:#cbd6e2;color:#506e91;border:1px solid #7c98b6;}"]);
export const Button = ({
  children,
  href,
  target,
  sbTrackName,
  sbTrackValue
}) => {
  return /*#__PURE__*/_jsx(StyledButton, {
    href: href,
    target: target,
    "data-sb-track-name": sbTrackName,
    "data-sb-track-value": sbTrackValue,
    children: children
  });
};